<template lang="pug">
.sidebar-item(
  :class="[{'sidebar-item--active': item._active}, `sidebar-item--${level}`]",
  @click.stop="onClick",
)
  .sidebar-item__item
    i.iconfont(:class="item.icon")
    .sidebar-item__item__preicon(v-if="level === 1 && item.children")
      i.iconfont.icon-minus1-copy-copy(v-if="expanded")
      i.iconfont.icon-plus1(v-else)
    span(v-if="!isCollapse") {{ $t(item.label) }}
  .sidebar-item__sub(
    v-if="item.children && !isCollapse",
    v-show="expanded",
  )
    sidebar-item(
      v-for="(item, index) in item.children",
      :key="index",
      :item="item",
      :level="level + 1"
      @change="$emit('change', $event)",
    )
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    level: {
      type: Number
    }
  },
  data () {
    return {
      expanded: this.item._active, // eslint-disable-line
      isCollapse: false
    }
  },
  computed: {
    isSidebarCollapse () {
      return this.$store.state.common.isCollapse
    }
  },
  methods: {
    onClick () {
      this.$emit('change', this.item.path)
      this.expanded = !this.expanded
    }
  },
  mounted () {
    if (this.isCollapse) {
      setTimeout((_) => { // eslint-disable-line
        this.isCollapse = this.isSidebarCollapse
      }, 400)
    } else {
      this.isCollapse = this.isSidebarCollapse
    }
  },
  watch: {
    item () {
      this.expanded = this.item._active // eslint-disable-line
    },
    isSidebarCollapse () {
      if (this.isCollapse) {
        setTimeout((_) => { // eslint-disable-line
          this.isCollapse = this.isSidebarCollapse
        }, 400)
      } else {
        this.isCollapse = this.isSidebarCollapse
      }
    }
  }
}
</script>

<style lang="stylus">
.sidebar-item
  position relative
  cursor pointer
  color $sidebar-color

.sidebar-item--active > .sidebar-item__item
  color #00b7ff

.sidebar>.sidebar-item--active>.sidebar-item__item
  color $sidebar-active-color
  background $sidebar-active-background

.sidebar-item__item
  padding 5px 0
  padding-left 47px

.sidebar-item--0 > .sidebar-item__item
  padding $sidebar-padding
  padding-left 30px

.sidebar-item--0 > .sidebar-item__sub
  padding-left 0

.sidebar-item__sub
  padding-left 20px
  font-size 13px

.sidebar-item--0
  .icon-angle-right
  .icon-angle-down
    position absolute
    top 15px
    right 20px

.sidebar-item--1 .sidebar-item__item__preicon
  position absolute
  top 7px
  left 45px

.sidebar-item__item i
  margin-right 20px
</style>
